export const mutations = {
  SET_PAYMENTS (state: any, data: any) {
    state.payments = data
  }
}
